import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  VStack,
  useToast,
  FormControl,
  FormLabel,
  FormErrorMessage
} from '@chakra-ui/react';
import { useState } from 'react';
import { registerAdmin } from '../../services/api';

{/*}
const [roles, setRoles] = useState([]);

useEffect(() => {
  axios.get('https://api.myseraph.eu/api/v1/roles')
    .then(response => {
      setRoles(response.data);
    })
    .catch(error => {
      console.error("Errore nel recupero dei ruoli:", error);
    });
}, []);
*/}

const AddUserModal = ({ isOpen, onClose, setUsers }) => {
  const toast = useToast();
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    password_confirmation: ''
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validate = () => {
    const newErrors = {};
    if (!form.name) newErrors.name = 'Il nome è obbligatorio';
    if (!form.email) newErrors.email = 'L\'email è obbligatoria';
    if (!/\S+@\S+\.\S+/.test(form.email)) newErrors.email = 'Email non valida';
    if (!form.password) newErrors.password = 'La password è obbligatoria';
    if (form.password !== form.password_confirmation) newErrors.password_confirmation = 'Le password non coincidono';
    return newErrors;
  };

  const handleSubmit = async () => {
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast({
        title: 'Campi obbligatori mancanti',
        status: 'error',
        isClosable: true
      });
      return;
    }

    try {
      const storedUser = JSON.parse(localStorage.getItem('user'));
      const companyId = storedUser?.customer_id;

      await registerAdmin(companyId, form);
      toast({ title: 'Utente creato con successo', status: 'success' });

      setUsers((prev) => [...prev, { ...form, id: Date.now() }]); // o aggiorna con response reale
      onClose();
      setForm({ name: '', email: '', phone: '', password: '', password_confirmation: '' });
      setErrors({});
    } catch (err) {
      toast({
        title: 'Errore durante la creazione utente',
        description: err.response?.data?.message || err.message,
        status: 'error',
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}  isCentered>
      <ModalOverlay />
      <ModalContent maxW="90vw" w="60vw">
        <ModalHeader>Aggiungi Utente</ModalHeader>
        <ModalCloseButton />
        <ModalBody maxH="40vh" overflowY="auto" pb={4}>
          <VStack spacing={3}>
            <FormControl isInvalid={!!errors.name}>
              <FormLabel>Nome</FormLabel>
              <Input name="name" value={form.name} onChange={handleChange} />
              <FormErrorMessage>{errors.name}</FormErrorMessage>
            </FormControl>

            <FormControl isInvalid={!!errors.email}>
              <FormLabel>Email</FormLabel>
              <Input name="email" value={form.email} onChange={handleChange} />
              <FormErrorMessage>{errors.email}</FormErrorMessage>
            </FormControl>

            <FormControl>
              <FormLabel>Telefono</FormLabel>
              <Input name="phone" value={form.phone} onChange={handleChange} />
            </FormControl>

            <FormControl isInvalid={!!errors.password}>
              <FormLabel>Password</FormLabel>
              <Input name="password" type="password" value={form.password} onChange={handleChange} />
              <FormErrorMessage>{errors.password}</FormErrorMessage>
            </FormControl>

            <FormControl isInvalid={!!errors.password_confirmation}>
              <FormLabel>Conferma Password</FormLabel>
              <Input name="password_confirmation" type="password" value={form.password_confirmation} onChange={handleChange} />
              <FormErrorMessage>{errors.password_confirmation}</FormErrorMessage>
            </FormControl>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="teal" mr={3} onClick={handleSubmit}>
            Aggiungi
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Annulla
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddUserModal;
